/* IMS header: Products mega menu behaviour.
   Hover opening is pure CSS (.ims-header__menu-item--mega:hover). This adds the
   `is-open` state used for keyboard focus and touch screens (where hover
   doesn't exist), keeps aria-expanded in sync, and closes on Escape or a click
   outside. Desktop widths only — below 990px the link simply navigates. */
(() => {
  const DESKTOP = window.matchMedia('(min-width: 990px)');
  const NO_HOVER = window.matchMedia('(hover: none)');

  document.querySelectorAll('.ims-header__menu-item--mega').forEach((item) => {
    const link = item.querySelector('.ims-header__menu-link');
    const panel = item.querySelector('.ims-mega-menu');
    if (!link || !panel) return;

    // Set after Escape so refocusing the link doesn't immediately re-open the panel
    let dismissed = false;

    const isOpen = () => item.classList.contains('is-open');
    const setOpen = (open) => {
      item.classList.toggle('is-open', open);
      link.setAttribute('aria-expanded', String(open));
    };

    // Mirror the CSS hover state into aria-expanded for assistive tech
    item.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'mouse' && DESKTOP.matches) link.setAttribute('aria-expanded', 'true');
    });
    item.addEventListener('pointerleave', (event) => {
      dismissed = false;
      if (event.pointerType === 'mouse' && !isOpen()) link.setAttribute('aria-expanded', 'false');
    });

    // Touch / pen: first tap opens the panel, second tap follows the link
    link.addEventListener('click', (event) => {
      if (!DESKTOP.matches || !NO_HOVER.matches || isOpen()) return;
      event.preventDefault();
      setOpen(true);
    });

    // Keyboard: tabbing onto the link (or into the panel) opens it so its links are reachable
    item.addEventListener('focusin', () => {
      if (!DESKTOP.matches || dismissed) return;
      setOpen(true);
    });
    item.addEventListener('focusout', (event) => {
      if (item.contains(event.relatedTarget)) return;
      dismissed = false;
      setOpen(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !item.contains(document.activeElement)) return;
      dismissed = true;
      setOpen(false);
      link.focus({ preventScroll: true });
    });

    document.addEventListener('click', (event) => {
      if (isOpen() && !item.contains(event.target)) setOpen(false);
    });
  });
})();
